import SectionCard from '../../components/SectionCard.jsx';
import { areaOf, failingChecks } from '../../lib/security-checks.js';
import { SeverityWord, compactRefs } from './parts.jsx';

export const FIX_FIRST_COUNT = 5;

/**
 * Fix first (Security, mockup 2): the failing checks, most severe first, each with its severity in words, its area, a
 * one-line remediation and up to two control references. Shows 5; the header action applies the Failed filter to All
 * checks and scrolls to it. A check title opens that check in the table.
 */
export default function FixFirst({ findings, onShowAllFailing, onOpenCheck }) {
  const failing = failingChecks(findings);
  const top = failing.slice(0, FIX_FIRST_COUNT);
  return (
    <SectionCard
      title="Fix first"
      description="Failing checks, most severe first"
      action={failing.length > 0 ? (
        <button type="button" className="tap text-left text-ipc-light hover:underline" onClick={onShowAllFailing}>
          {failing.length === 1 ? 'Show the failing check in the table' : `Show all ${failing.length} failing checks in the table`}
        </button>
      ) : null}
      testId="security-fix-first"
    >
      {top.length === 0 ? (
        <p className="text-sm text-ipc-muted">No failing checks on the latest collection.</p>
      ) : (
        <ol className="divide-y divide-ipc-border">
          {top.map((f, i) => {
            const area = areaOf(f);
            const refs = compactRefs(f);
            return (
              <li key={f.id ?? i} className="flex flex-col gap-2 py-3 first:pt-1 sm:flex-row sm:items-start sm:gap-3" data-fix={f.id}>
                <span aria-hidden="true" className="w-6 shrink-0 font-display text-lg font-extrabold leading-tight text-ipc-primary">{i + 1}</span>
                <div className="min-w-0 flex-1">
                  <button type="button" className="tap text-left font-semibold text-ipc-ink hover:text-ipc-light hover:underline" onClick={() => onOpenCheck?.(f.id)}>
                    {f.title}
                  </button>
                  {refs.length ? (
                    <span className="ml-2 inline-flex flex-wrap gap-1.5 align-middle">
                      {refs.map((r) => <span key={r} className="rounded border border-ipc-border px-1.5 text-[11.5px] font-medium text-ipc-muted">{r}</span>)}
                    </span>
                  ) : null}
                  {f.remediation ? <p className="mt-0.5 text-[13px] text-ipc-muted">{f.remediation}</p> : null}
                </div>
                <span className="flex shrink-0 items-center gap-3 whitespace-nowrap text-[13px] text-ipc-muted sm:ml-auto">
                  <SeverityWord severity={f.severity} />
                  {area ? <span>{area}</span> : null}
                </span>
              </li>
            );
          })}
        </ol>
      )}
    </SectionCard>
  );
}
